var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"none-container"},[_c('img',{staticClass:"none",attrs:{"src":_vm.nonePng}})])}
var staticRenderFns = []

export { render, staticRenderFns }